import { z } from 'zod';

export const hqOperatingKindSchema = z.enum([
  'hazardEquipment',
  'safetyBudgetItems',
  'safetyBudgetMonthly',
  'emergencyDrills',
  'workPlans',
  'workPermits',
]);
export type HqOperatingKind = z.infer<typeof hqOperatingKindSchema>;
export const hqOperatingViewSchema = z
  .object({
    archiveId: z.string().regex(/^hq-source-[a-f0-9]{48}$/u),
    kind: hqOperatingKindSchema,
    title: z.string().max(2000),
    company: z.string().max(1000),
    template: z.boolean(),
    fields: z
      .array(z.object({ label: z.string().max(300), value: z.string().max(20000) }).strict())
      .max(100),
    rows: z
      .array(z.object({ label: z.string().max(300), value: z.string().max(20000) }).strict())
      .max(500),
    mediaReferenceCount: z.number().int().nonnegative(),
  })
  .strict();
export type HqOperatingView = z.infer<typeof hqOperatingViewSchema>;
export const hqOperatingPageSchema = z
  .object({
    items: z.array(hqOperatingViewSchema).max(30),
    nextCursor: z
      .string()
      .regex(/^hq-source-[a-f0-9]{48}$/u)
      .nullable(),
    heldCount: z.number().int().nonnegative().max(30),
  })
  .strict();
export type HqOperatingPage = z.infer<typeof hqOperatingPageSchema>;

export const hqEquipmentSourceDraftSchema = z.object({
  name: z.string().max(2000), modelNo: z.string().max(2000), location: z.string().max(2000), capacity: z.string().max(2000),
  inspectionDate: z.string().max(100), expiryDate: z.string().max(100), inspectionResult: z.string().max(2000),
  inspector: z.string().max(2000), issues: z.string().max(10000), note: z.string().max(10000),
}).strict();
export type HqEquipmentSourceDraft = z.infer<typeof hqEquipmentSourceDraftSchema>;
export const hqEquipmentSourceDraftSnapshotSchema = z.object({
  archiveId: z.string().regex(/^hq-source-[a-f0-9]{48}$/u), sourceHash: z.string().regex(/^[a-f0-9]{64}$/u),
  version: z.number().int().nonnegative(), draft: hqEquipmentSourceDraftSchema, canEdit: z.boolean(), updatedAt: z.string().datetime().nullable(),
}).strict();
export type HqEquipmentSourceDraftSnapshot = z.infer<typeof hqEquipmentSourceDraftSnapshotSchema>;
